import cx from 'classnames';

export const getFieldContainerStylesAsClassName = (
  disabled = false,
  isFocused = false,
  isInvalid = false,
  readOnly = false,
  hasBorder = true,
  hasCaret = true
) => {
  return cx(
    'overflow-hidden',
    'border-[1.5px]',
    'border-solid',
    'border-primary-main',
    'bg-white',
    'rounded-full',
    'flex',
    'w-full',
    'hover:border-primary-dark',
    'active:border-primary-dark',
    // Focus-within outline for keyboard accessibility - only when hasBorder is true
    // Uses consistent primary-main color for all states (editable, readonly, disabled)
    {
      'focus-within:outline focus-within:outline-2 focus-within:outline-offset-2 focus-within:outline-primary-main':
        hasBorder,
      'bg-gray-xxlight border-primary-main': readOnly || disabled,
      'bg-error-light border-error-main focus-within:outline-error-main':
        hasBorder && isInvalid,
      'border-primary-dark': isFocused,
      'border-none hover:border-none': !hasBorder,
      'caret-transparent': !hasCaret,
    }
  );
};
